<div class="container-fluid p-4 main-container pb-5">
  <!-- Loading Overlay -->
  @if(loading){
  <div class="overlay">
    <div class="spinner-border text-primary"></div>
  </div>
  }

  <div class="row g-4 mb-4 ">
    <!-- Left: Product Summary Card -->
    <div class="col-lg-8">
      <div class="card border-0 shadow-sm premium-card h-100">
        <div class="card-body p-4">
          <div class="row align-items-center">
            <div class="col-md-4" style="border:1px solid #F3F4F6;border-radius: 12px;">
              <div class="img-wrapper rounded-3 overflow-hidden  d-flex align-items-center justify-content-center" style="height: 200px;">
                @if(articleImage){
                  <img [src]="articleImage" class="product-img" alt="Product" />
                }@else {
                  <img src="assets/images/fruits_dummy.png" class="product-img" alt="Product" />
                }
              </div>
            </div>
            <div class="col-md-8">
              <h3 class="product-name mb-4">
                {{ orderDetails.article?.article }} {{ orderDetails.article?.variety ? '- ' + orderDetails.article?.variety : '' }}
              </h3>
              
              <div class="metrics-grid">
                <div class="metric-box">
                  <span class="label">UOM</span>
                  <span class="value">{{ orderDetails.uom || 'Metric Ton' }}</span>
                </div>
                <div class="metric-box">
                  <span class="label">QUANTITY</span>
                  <span class="value">{{ orderDetails.quantity | number }}</span>
                </div>
                <div class="metric-box">
                  <span class="label">UNIT PRICE</span>
                  <span class="value">{{ orderDetails.currency }} {{ orderDetails.unitSellingPrice| number:'1.2-2' }}</span>
                </div>
                <div class="metric-box highlighted">
                  <span class="label">TOTAL PRICE </span>
                  <span class="value">{{ orderDetails.currency }} {{ orderDetails.unitSellingPrice * orderDetails.quantity | number:'1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right: Shipment Information -->
    <div class="col-lg-4">
      <div class="card border-0 shadow-sm premium-card h-100">
        <div class="card-body p-4">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h6 class="section-title-sm m-0 d-flex align-items-center gap-2">
              <img src="icons/shipment-tracking.svg" alt="shipment-tracking" class="section-icon">
              SHIPMENT DETAILS</h6>
            <span class="badge badge-status" [ngClass]="statusClass(orderDetails.status)">
              {{ orderDetails.status | uppercase }}
            </span>
          </div>

          <!-- Vertical Timeline -->
          <div class="shipment-timeline">
            <div class="timeline-item">
              <div class="timeline-icon ">
                 <img src="icons/destination-shipment-tracking.svg" alt="Origin">
              </div>
              <div class="timeline-content">
                <span class="label">ORIGIN</span>
                <span class="value">{{ orderDetails.sourcePort }}</span>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-icon">
                <img src="icons/origin-shipment-tracking.svg" alt="Route">
              </div>
              <div class="timeline-content">
                <span class="label">ROUTE</span>
                <span class="value">{{ orderDetails.route  }}</span>
              </div>
            </div>
            <div class="timeline-item last">
              <div class="timeline-icon">
                <img src="icons/route-shipment-tracking.svg" alt="Destination">
              </div>
              <div class="timeline-content">
                <span class="label">DESTINATION</span>
                <span class="value">{{ orderDetails.destinationPort }}</span>
              </div>
            </div>
          </div>

          <div class="mt-4 pt-4 border-top">
            <label class="dropdown-label mb-2">UPDATE STATUS</label>
            <mat-select [formControl]="orderUpdate" placeholder="Select Status" (selectionChange)="updateOrderStatus()" class="form-control-custom">
              @for(status of orderStatusList; track $index){
                <mat-option [value]="status.displayText">{{status.displayText}}</mat-option>
              }
            </mat-select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Order Items Table -->
  <div class="card  shadow-sm premium-card mb-4 p-0" style="border:1px solid #E5E7EB;border-radius: 12px;">
    <div class="card-body p-0">
      <h3 class="section-title mb-0 ">Order Items</h3>
      <div class="table-responsive">
        <table class="table modern-table mb-0">
          <thead>
            <tr>
              <th>ITEM DESCRIPTION</th>
              <th>UOM</th>
              <th class="text-end">UNIT PRICE
                  
              </th>
              <th class="text-end">QUANTITY</th>
              <th class="text-end">TOTAL PRICE </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="fw-bold">{{ orderDetails.article?.article }} {{ orderDetails.article?.variety ? '(' + orderDetails.article?.variety + ')' : '' }}</td>
              <td>{{ orderDetails.uom }}</td>
              <td class="text-end">{{ orderDetails.currency }} {{ orderDetails.unitSellingPrice | number:'1.2-2' }}</td>
              <td class="text-end">{{ orderDetails.quantity }}</td>
              <td class="text-end fw-bold">{{ orderDetails.currency }} {{ orderDetails.unitSellingPrice * orderDetails.quantity | number:'1.2-2' }}</td>
            </tr>
            <!-- Placeholders for extra items if needed by user -->
            <tr class="total-row">
              <td colspan="4" class="text-start pt-4">
                <span class="total-label">Order Total</span>
              </td>
              <td class="text-end pt-4">
                <span class="total-value">{{ orderDetails.currency }} {{ orderDetails.unitSellingPrice * orderDetails.quantity | number:'1.2-2' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Documents Section -->
  <div class="card border-0 shadow-sm premium-card pb-5 mb-5">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-file-earmark-text-fill" style="color:#9CA3AF"></i>
          <h3 class="section-title-doc m-0">Documents</h3>
        </div>
      </div>

      

      <!-- Upload Zone -->
      <div class="form-group mb-4">
        
        <div class="upload-dropzone" (click)="triggerFileInput('ORDER')" (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
          <i class="bi bi-cloud-upload-fill upload-icon"></i>
          <p class="upload-text">Click to upload or drag and drop</p>
          <p class="upload-hint">PDF, JPG or PNG (max. 10MB)</p>
        </div>
      </div>
      <input type="file" #fileInput style="display: none" (change)="handleFileSelect($event)" accept="image/*,application/pdf,.doc,.docx" />

      <!-- File list as shown in design -->
      @if(documents && documents.length > 0) {
      <div class="file-list">
        @for(file of documents; track file){
        <div class="file-item">
          <div class="file-info" (click)="viewMediaFile(file)">
            @if(file.contentType && file.contentType.includes('image')){
            <img [src]="file.fileUrl" alt="" class="file-icon" style="max-height: 40px; max-width: 40px; object-fit: contain;">
            }
            @else if(file.contentType && file.contentType.includes('application/pdf')){
            <i class="bi bi-file-earmark-pdf-fill file-icon" style="font-size: 1.5rem; color: #ef4444;"></i>
            }
            @else if(file.contentType && file.contentType.includes('application/msword')){
            <i class="bi bi-file-earmark-word-fill file-icon" style="font-size: 1.5rem; color: #2b579a;"></i>
            }
            @else{
            <i class="bi bi-file-earmark-text-fill file-icon" style="font-size: 1.5rem; color: #6c757d;"></i>
            }

            <div class="file-meta">
              <span class="file-name">{{file.fileName}}</span>
            </div>
          </div>
          <button type="button" class="btn-remove-file" (click)="deleteMedia(file.id)">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        }
      </div>
      }
      @if(!documents || documents.length === 0){
        <div class="col-12 text-center py-4 text-muted">
          <p class="m-0">No documents uploaded yet.</p>
        </div>
      }
    </div>
  </div>
</div>
